import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { AxiosResponse } from 'axios'

interface PropsPostConsultoria {
  nome: string
  cpf_cnpj: string
  endereco: string
  comple: string
  cep: string
  cod_cidade: number
  fone: string
  fone2: string
  email: string
  logo: any
  refetch: Function
}

export const usePostConsultoria = (): {
  carregando_salvar_consultoria: boolean
  mutate_consultoria: (params: PropsPostConsultoria) => void
  isSuccess_consultoria: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostConsultoria> = useMutation(
    async (params: PropsPostConsultoria) => {
      const {
        nome,
        cpf_cnpj,
        endereco,
        comple,
        cep,
        cod_cidade,
        fone,
        fone2,
        email,
        logo,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`/consultoria?codConta=${localConfig()?.conta}`, {
          nome: nome,
          cpf_cnpj: cpf_cnpj,
          endereco: endereco,
          comple: comple,
          cep: cep,
          cod_cidade: cod_cidade,
          fone: fone,
          fone2: fone2,
          email: email,
          logo: logo,
          refetch: refetch,
        })
        .then((response: any) => {
          successAlert('Fertilizante cadastrado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar fertilizante!', 5000, 'loading')
            })
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar fertilizante!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_consultoria: mutation.isLoading,
    mutate_consultoria: mutation.mutate,
    isSuccess_consultoria: mutation.isSuccess,
  }
}

export const postCadastroConsultoria = async (data, limpar, setLoading) => {
  const config = localConfig();

  loadingAlert({msg: 'Salvando...', id: 'cadastro_conta'})

  api.defaults.headers.Acesso = config.acesso

  const response: AxiosResponse<PropsPostConsultoria> = await api
    .post('/consultoria', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((): any => {
      setTimeout(() => {
        successAlert('Informações da consultoria foram salvo com sucesso!', 5000, 'cadastro_conta')
      }, 100)

      limpar()
      setLoading(false)
    })
    .catch((error) => {
      errorAlert(`${error?.response?.data?.error}`, 5000, 'cadastro_conta')
    })

  return response
}

export const postCadastroConsultoriaEditar = async (cod, data, limpar, setLoading) => {
  const config = localConfig();

  loadingAlert({msg: 'Salvando...', id: 'editar_conta'})

  api.defaults.headers.Acesso = config.acesso

  const response: AxiosResponse<PropsPostConsultoria> = await api
    .post(`/consultoria/${cod}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((): any => {
      setTimeout(() => {
        successAlert('Informações da consultoria foram editadas com sucesso!', 5000, 'editar_conta')
      }, 100)

      limpar()
      setLoading(false)
    })
    .catch((error) => {
      errorAlert(`${error?.response?.data?.error}`, 5000, 'editar_conta')
    })

  return response
}